import { Component, computed, NgModule, OnInit, signal } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatToolbar, MatToolbarModule } from "@angular/material/toolbar";
import { MatTabsModule } from "@angular/material/tabs";
import { ServiceCardComponent } from "../service-card/service-card.component";
import { NgbModule, NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { GaugeChartComponent } from "../../device-detail-nxt/gauge-chart-component/gauge-chart-component.component";
import { BackendApiService } from "../../../../app/services/backend-api.service";
import { FormsModule, NgModel } from "@angular/forms";
import { ConvertDatetimePipe } from "../../../../app/convert-datetime.pipe";
import { UptimeChartContainerComponent } from "../uptime-charts-container/uptime-charts-container.component";
import { BaseUrlConstantsService } from "../../../../app/services/base-url-constants.service";

@Component({
  selector: "app-uptime-dashboard",
  templateUrl: "./uptime-dashboard.component.html",
  styleUrls: ["./uptime-dashboard.component.scss"],
  standalone: true,
  imports: [
    MatToolbarModule,
    MatTabsModule,
    NgbModule,
    NgbNavModule,
    CommonModule,
    GaugeChartComponent,
    FormsModule,
    UptimeChartContainerComponent
  ],
})
export class UptimeDashboardComponent implements OnInit {
  mqttLoader: boolean = true;
  public today: string;
  company_name: string = "";
  service_loader = true;
  selectedMonth: string = (new Date().getMonth() + 1)
    .toString()
    .padStart(2, "0");
  activeTab: "applications" | "servers" = "applications";
  selected_time_range_txt = "";
  private uptime_base_url = BaseUrlConstantsService.BASE_UPTIME_SERVICE;
  public breadcrumbsArray: any = [
    {
      page_ref: "device-reports",
      page_title: "All Cylinders",
    },
    {
      page_ref: "#",
      page_title: "Monitoring Analysis",
    },
  ];

  mqttObj: any = {};
  avtive_tab = "tab-1";
  universal_gauge_data = {
    gaugeData: {
      needleValue: null,
      centralLabel: "",
      outerNeedle: false,
      canvasWidth: 150,
      name: "",
      key: "flow",
      bottomLabel: "",
      hasneedle: true,
      options: {
        centralLabel: "",
        hasNeedle: true,
        needleColor: "#ff2a1b",
        needleUpdateSpeed: "",
        arcColors: ["#ff2a1b", "#FAA700", "#72FF13"],
        arcLabels: ["90.00", "95.00"],
        arcDelimiters: [90, 95],
        rangeLabel: ["0", "100"],
        needleStartValue: 0,
      },
    },
    modalData: {
      id: 36635,
      metric_type: "Service",
      base_value: 0,
      max_value: 100,
      threshold_1: 90,
      threshold_2: 95,
      threshold_3: 100,
    },
  };
  mqtt_data: any = { service: {}, processing: {} };
  iot_data: any = { service: {}, processing: {} }; // combines for all iotbot instances
  iot_data_single: any = { service: {}, processing: {} }; // combines for all iotbot instances
  kurtosis_data: any = { service: {}, processing: {} };
  combined_data: any = { service: {}, processing: {}, data: {} };
  db_data: any = {};
  os_data: any = {};
  combined_os_gauge: any = { processing: {} };

  constructor(private srv: BackendApiService) {}

  async ngOnInit() {
    this.mqttLoader = true;
    this.service_loader = true;
    await this.getMqttData();
    await this.getServerData();
    this.company_name = localStorage.getItem("company_name");
    this.utcTime();
    this.selected_time_range_txt = this.getDateRange(this.selectedMonth);
  }

  getMqttData() {
    this.mqttLoader = true;
    this.srv
      // .getDataV2("http://localhost:7779/uptime/monthly-data/${this.selectedMonth}/application")
      .getDataV2(`${this.uptime_base_url}/uptime/monthly-data/${this.selectedMonth}/application`)
      .then((data: any) => {
        const { body, code, status } = data;
        if (code == 200 && status == "success") {
          const { mqtttData, iotData, kurtosisData } = body;
          this.mqtt_data = mqtttData;
          this.mqtt_data.service = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );
          this.mqtt_data.processing = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );

          this.mqtt_data.service.gaugeData.needleValue = mqtttData.uptime_total;
          this.mqtt_data.service.gaugeData.centralLabel = `${mqtttData.uptime_total}%`;
          this.mqtt_data.service.gaugeData.bottomLabel = `${mqtttData.uptime_total}%`;
          this.mqtt_data.service.gaugeData.name = `Service`;

          this.mqtt_data.processing.gaugeData.needleValue =
            mqtttData.processing_total;
          this.mqtt_data.processing.gaugeData.centralLabel = `${mqtttData.processing_total}%`;
          this.mqtt_data.processing.gaugeData.bottomLabel = `${mqtttData.processing_total}%`;
          this.mqtt_data.processing.gaugeData.name = `Processing`;

          // ------------------------- IOT DATA -------------------------
          this.iot_data = iotData; // universal for all 3 combined iot servers
          this.iot_data_single = {
            processing_data: iotData.instance_processing,
            service_data: iotData.instance_uptime,
          };
          this.iot_data.service = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );
          this.iot_data.processing = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );

          this.iot_data.service.gaugeData.needleValue = iotData.uptime_total;
          this.iot_data.service.gaugeData.centralLabel = `${iotData.uptime_total}%`;
          this.iot_data.service.gaugeData.bottomLabel = `${iotData.uptime_total}%`;
          this.iot_data.service.gaugeData.name = `Service`;

          this.iot_data.processing.gaugeData.needleValue =
            iotData.processing_total;
          this.iot_data.processing.gaugeData.centralLabel = `${iotData.processing_total}%`;
          this.iot_data.processing.gaugeData.bottomLabel = `${iotData.processing_total}%`;
          this.iot_data.processing.gaugeData.name = `Processing`;

          // SINGLE INSTANCE LEVEL
          Object.keys(this.iot_data_single.service_data).map((instance) => {
            let value=(this.iot_data_single.service_data[instance]).toFixed(2);
            this.iot_data_single.service_data[instance]={};
            this.iot_data_single.service_data[instance]['service'] ??= JSON.parse(
              JSON.stringify(this.universal_gauge_data)
            );
            this.iot_data_single.service_data[instance].service.gaugeData.needleValue = value;
            this.iot_data_single.service_data[instance].service.gaugeData.centralLabel = `${value}%`;
            this.iot_data_single.service_data[instance].service.gaugeData.bottomLabel = `${value}%`;
            this.iot_data_single.service_data[instance].service.gaugeData.name = `${instance} `;
          });
          Object.keys(this.iot_data_single.processing_data).map((instance) => {
            let value=(this.iot_data_single.processing_data[instance]).toFixed(2);
            this.iot_data_single.processing_data[instance]={};
            this.iot_data_single.processing_data[instance]['processing'] ??= JSON.parse(
              JSON.stringify(this.universal_gauge_data)
            );
            this.iot_data_single.processing_data[instance].processing.gaugeData.needleValue = value;
            this.iot_data_single.processing_data[instance].processing.gaugeData.centralLabel = `${value}%`;
            this.iot_data_single.processing_data[instance].processing.gaugeData.bottomLabel = `${value}%`;
            this.iot_data_single.processing_data[instance].processing.gaugeData.name = `${instance}`;
          });

          // ------------------------- KURTOSIS DATA -------------------------
          this.kurtosis_data = kurtosisData;
          this.kurtosis_data.service = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );
          this.kurtosis_data.processing = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );

          this.kurtosis_data.service.gaugeData.needleValue =
            kurtosisData.uptime_total;
          this.kurtosis_data.service.gaugeData.centralLabel = `${kurtosisData.uptime_total}%`;
          this.kurtosis_data.service.gaugeData.bottomLabel = `${
            parseFloat(kurtosisData.uptime_total) <= 0
              ? "N/A"
              : kurtosisData.uptime_total + "%"
          }`;
          this.kurtosis_data.service.gaugeData.name = `Service`;

          this.kurtosis_data.processing.gaugeData.needleValue =
            parseFloat(kurtosisData.processing_total) <= 0
              ? "N/A"
              : kurtosisData.processing_total;
          this.kurtosis_data.processing.gaugeData.centralLabel = `${
            parseFloat(kurtosisData.processing_total) <= 0
              ? "N/A"
              : kurtosisData.processing_total + "%"
          }`;
          this.kurtosis_data.processing.gaugeData.bottomLabel = `${
            parseFloat(kurtosisData.processing_total) <= 0
              ? "N/A"
              : kurtosisData.processing_total + "%"
          }`;
          this.kurtosis_data.processing.gaugeData.name = `Processing`;
          //--------------------------COMBINED DATA------------------------
          let services = [
            {
              name: "mqtt",
              uptime_avg: mqtttData.uptime_total,
              processing_total: mqtttData.processing_total,
              weight: mqtttData.weight,
            },
            {
              name: "iot",
              uptime_avg: iotData.uptime_total,
              processing_total: iotData.processing_total,
              weight: iotData.weight,
            },
            {
              name: "kutosis",
              uptime_avg: kurtosisData.uptime_total,
              processing_total: kurtosisData.processing_total,
              weight: kurtosisData.weight,
            },
          ];
          const totalWeight = services.reduce((sum, s) => sum + s.weight, 0);
          const uptime_weighted_sum = services.reduce(
            (sum, s) => sum + s.uptime_avg * s.weight,
            0
          );
          const processing_weighted_sum = services.reduce(
            (sum, s) => sum + s.processing_total * s.weight,
            0
          );
          const combined_uptime_perc = uptime_weighted_sum / totalWeight;
          const combined_processing_perc =
            processing_weighted_sum / totalWeight;

          this.combined_data.service = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );
          this.combined_data.processing = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );

          this.combined_data.service.gaugeData.needleValue =
            combined_uptime_perc;
          this.combined_data.service.gaugeData.centralLabel = `${combined_uptime_perc.toFixed(
            2
          )}%`;
          this.combined_data.service.gaugeData.bottomLabel = `${combined_uptime_perc.toFixed(
            2
          )}%`;
          this.combined_data.service.gaugeData.name = `Service`;

          this.combined_data.processing.gaugeData.needleValue =
            combined_processing_perc;
          this.combined_data.processing.gaugeData.centralLabel = `${combined_processing_perc.toFixed(
            2
          )}%`;
          this.combined_data.processing.gaugeData.bottomLabel = `${combined_processing_perc.toFixed(
            2
          )}%`;
          this.combined_data.processing.gaugeData.name = `Processing`;
        }
        this.mqttLoader = false;
      })
      .catch((err) => {
        console.error(err);
        this.mqttLoader = false;
      });
  }

  getServerData() {
    this.service_loader = true;
    this.srv
      // .getDataV2("http://localhost:7779/uptime/monthly-data/${this.selectedMonth}/server")
      .getDataV2(`${this.uptime_base_url}/uptime/monthly-data/${this.selectedMonth}/server`)
      .then((data: any) => {
        const { body, code, status } = data;

        if (code != 200 || status != "success") {
          throw Error("errprrrrfef");
        }
        const { db_total } = body.db;
        db_total.map((db) => {
          db[`processing`] = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );
          db[`processing`].gaugeData.needleValue = db.total;
          db[`processing`].gaugeData.centralLabel = `${db.total}%`;
          db[`processing`].gaugeData.bottomLabel = `${db.total}%`;
          db[`processing`].gaugeData.name = db.name;
        });
        this.db_data = db_total;
        this.service_loader = false;
        const { os_total } = body.os;
        os_total.map((os) => {
          os[`processing`] = JSON.parse(
            JSON.stringify(this.universal_gauge_data)
          );
          os[`processing`].gaugeData.needleValue = os.total;
          os[`processing`].gaugeData.centralLabel = `${os.total}%`;
          os[`processing`].gaugeData.bottomLabel = `${os.total}%`;
          os[`processing`].gaugeData.name = os.name;
        });
        this.os_data = os_total;
        this.service_loader = false;
        let server_combined = [...this.os_data, ...this.db_data];

        const totalWeight = server_combined.reduce(
          (sum, s) => sum + parseFloat(s.weight),
          0
        );
        const calculated_sum = server_combined.reduce(
          (sum, s) => sum + parseFloat(s.total) * parseFloat(s.weight),
          0
        );
        const combined_os = calculated_sum / totalWeight;
        this.combined_os_gauge.processing = JSON.parse(
          JSON.stringify(this.universal_gauge_data)
        );
        this.combined_os_gauge.processing.gaugeData.needleValue = combined_os;
        this.combined_os_gauge.processing.gaugeData.centralLabel = `${combined_os.toFixed(
          2
        )}%`;
        this.combined_os_gauge.processing.gaugeData.bottomLabel = `${combined_os.toFixed(
          2
        )}%`;
        this.combined_os_gauge.processing.gaugeData.name = `Operating System`;
      })
      .finally(() => {});
  }

  onMonthChange(): void {
    this.loadUptimeData();
    this.selected_time_range_txt = this.getDateRange(this.selectedMonth);
  }

  // Refresh button handler
  refreshData(): void {
    this.mqttLoader = true;
    this.ngOnInit();
    // Simulate API call
    setTimeout(() => {
      this.loadUptimeData();
      this.mqttLoader = false;
    }, 2000);
  }

  private loadUptimeData(): void {
    // Your existing data loading logic here
    // This is where you would call your uptime calculation APIs
    // based on the selected month
    this.ngOnInit()


    // Example: You might call different methods based on selected month
    // this.uptimeService.getUptimeData(this.selectedMonth).subscribe(data => {
    //   this.mqtt_data = data.mqtt;
    //   this.iot_data = data.iot;
    //   this.kurtosis_data = data.kurtosis;
    // });
  }

  onTabChange(tab: "applications" | "servers") {
    this.activeTab = tab;

    // if you want to trigger data loading based on the tab:
    if (tab === "applications") {
      this.getMqttData();
    } else if (tab === "servers") {
      this.getServerData();
    }
  }

  utcTime() {
    setInterval(() => {
      this.today = new ConvertDatetimePipe().convertDateTime(new Date());
    }, 1000);
  }

  getDateRange(monthNumber) {
    const now = new Date();
    const monthIndex = parseInt(monthNumber, 10) - 1; // JS months are 0-based
    const year = now.getFullYear();

    // Month name for display
    const monthName = new Date(year, monthIndex, 1).toLocaleString("default", {
      month: "long",
    });

    if (now.getMonth() === monthIndex) {
      // Current month → from 1st to today's date
      return `1st ${monthName} - ${now.getDate() - 1}${this.getDaySuffix(
        now.getDate()
      )} ${monthName}`;
    } else {
      // Other month → 1st to last date of that month
      const lastDay = new Date(year, monthIndex + 1, 0).getDate();
      return `1st ${monthName} - ${lastDay}${this.getDaySuffix(
        lastDay
      )} ${monthName}`;
    }
  }

  // helper to add st/nd/rd/th
  getDaySuffix(day) {
    if (day >= 11 && day <= 13) return "th";
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  }
}
